export default __webpack_public_path__ + "static/media/closeSound.56ff918e.mp3";